.kicker {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-dialog);
}

.who {
  display: flex;
  align-items: center;
  gap: 14px;
}

.title {
  font-size: 24px;
}

.label {
  font-size: 14px;
  font-weight: 700;
}

.can {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.abilities {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding-left: 20px;
  font-size: 15px;
  line-height: 1.5;
}

/* Lilac, the colour of what stays with the patient. */
.private {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-radius: var(--radius-control);
  background: var(--private);
  color: var(--private-ink);
  font-size: 14px;
  line-height: 1.5;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 720px) {
  .actions {
    flex-direction: row;
  }
}

.accept,
.decline {
  flex: 1 1 0;
  min-height: 52px;
  padding: 0 24px;
  border: var(--outline);
  border-radius: var(--radius-control);
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
}

.accept {
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
}

.accept:active {
  box-shadow: none;
  transform: translate(3px, 3px);
}

.decline {
  background: var(--surface);
  color: var(--ink);
}

.accept:disabled,
.decline:disabled {
  background: var(--sunk);
  color: var(--ink-3);
  box-shadow: none;
  cursor: default;
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}

.sent {
  font-size: 14px;
  color: var(--ink-2);
}
